import React, { useRef } from "react";
import ScrollToTop from "../../components/scroll-to-top";
import SEO from "../../components/seo";
import AccordionContainer from "../../containers/accordion";
import NewsletterArea from "../../containers/global/newsletter";
import PageBanner from "../../containers/global/page-banner";
import Footer from "../../layouts/footer";
import Header from "../../layouts/header";
import Layout from "../../layouts/index";
import PartnersData from "../../data/partners.json";
import PartnersContainer from "../../containers/about-us/partners";
import IconBoxContainer from "../../containers/global/icon-box";

const PartnersPage = () => {
    const contRef = useRef(null);
    const handleScrollToHeader = () => {
        console.log("scrllheader", contRef);
        if (contRef.current) {
            console.log("scrllheader2");
            // Adjust scrolling to account for the height of the small div
            const headerPosition = contRef.current.offsetTop;
            const divHeight = 0; // Adjust this if your div's height changes
            window.scrollTo({
                top: headerPosition,
                behavior: "smooth",
            });
        }
    };
    return (
        <React.Fragment>
            <Layout>
                <SEO title="Partners | NeoGrowth - Lending simplified. Growth amplified." />
                <div className="wrapper">
                    <Header
                        onPressSkipButton={() => {
                            handleScrollToHeader();
                        }}
                    />
                    <PageBanner
                        title="Partners"
                        excerpt=""
                        image="/images/banner/page/stock-exchange.png"
                    />

                    <PartnersContainer contRef={contRef} data={PartnersData} />

                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default PartnersPage;
